import {Component, EventEmitter, Output} from '@angular/core';
import {CdkStepper} from "@angular/cdk/stepper";

@Component({
  selector: 'custom-onboarding',
  templateUrl: './onboarding.component.html',
  styles: [`
    :host {
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
    }
  `],
  providers: [{ provide: CdkStepper, useExisting: OnboardingComponent }],
})
export class OnboardingComponent extends CdkStepper {

  @Output() onClickLastNextButton = new EventEmitter<void>();

  @Output() onClickFirstPreviousButton = new EventEmitter<void>();

  next() {
    if (this.isLastStep()) {
      this.onClickLastNextButton.next();
    }
    super.next();
  }

  previous() {
    if (this.isFirstStep()) {
      this.onClickFirstPreviousButton.next();
    }
    super.previous();
  }

  isLastStep(): boolean {
    return this.selectedIndex === this.steps.length - 1;
  }

  isFirstStep(): boolean {
    return this.selectedIndex === 0;
  }

}
